function onDropdownClick(event) {
  const parentElement = event.target.closest('.dropdown');
  parentElement.classList.toggle('active');
}

export default () => {
  let dropdowns = document.querySelectorAll('.dropdown__button');
  dropdowns.forEach( (button) => button.addEventListener('click', onDropdownClick) )
}




// WEBPACK FOOTER //
// ./templates/floor/assets/js/jQueryApplication/esm/dropdown.js